import React from 'react';
import { useUserData, FrequencyOption } from '@/context/UserDataContext';
import { getSeafoodFrequencyOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface SeafoodConsumptionProps {
  error?: string;
  onComplete?: () => void;
}

const SeafoodConsumption: React.FC<SeafoodConsumptionProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const seafoodOptions = getSeafoodFrequencyOptions();

  const handleSeafoodConsumptionChange = (value: FrequencyOption) => {
    setUserData(prev => ({ ...prev, seafoodConsumption: value }));
  };

  return (
    <FormSection
      question="How often do you eat seafood?"
      helperText="This helps us assess your omega-3 fatty acid intake."
      error={error}
    >
      <AnimatedSelectionGroup
        options={seafoodOptions}
        value={userData.seafoodConsumption}
        onChange={handleSeafoodConsumptionChange}
        name="seafood-consumption"
        onComplete={onComplete}
      />
    </FormSection>
  );
};

export default SeafoodConsumption; 